import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import ReviewCard from '../Components/ReviewCard'
import Slider from 'react-slick';
import RichText from '../Components/RichText';
import { useLanguage } from '../i18n/LanguageContext';

export default function Home() {
  const { reviews, platform, ui } = useLanguage().content;
  const { home } = ui;

  function Arrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, background: "#c4a86b", color: "#c4a86b", width: "20px" }}
        onClick={onClick}
      />
    );
  }
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: <Arrow/>,
        nextArrow: <Arrow/>,
        centerMode: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 870,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1270,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1512,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                },
            },
        ],
      };

    return (
        <div className="bg-bgLight min-h-screen">
            <Navbar/>

            <div className="max-w-8xl mx-auto px-10 items-center">
                <div className="grid grid-cols-1 xl:grid-cols-[5fr_3fr] gap-10">
                    <div className="md:pl-16 w-full justify-center text-textDark min-w-3xl md:text-lg text-md flex flex-col gap-8 items-center">
                        <div className="flex justify-center">
                            <div className="rounded-full bg-white border border-secondary/30 shadow-md w-40 h-40 md:w-56 md:h-56 flex items-center justify-center">
                                <img src="/new-logo-2.png" alt={home.logoAlt} className="w-5/6 h-5/6 object-contain"/>
                            </div>
                        </div>

                        <h1 className="text-4xl font-serif font-bold text-primary">{home.title}</h1>
                        <p className="text-left text-textDark leading-relaxed">
                            <RichText text={home.intro} strongClassName="font-bold text-primary"/>
                        </p>
                        
                        <blockquote className="text-primary text-2xl font-serif italic border-l-4 border-secondary pl-6 py-2">
                            {home.hadith}
                            <span className="block font-normal text-sm text-accent mt-2">{home.hadithSource}</span>
                        </blockquote>

                        <p className="text-left leading-relaxed">
                            {home.belief}
                        </p>
                        <div className="w-fit bg-bgMuted/50 p-6 rounded-lg shadow-sm">
                            <ul className="font-semibold text-left space-y-3">
                                {home.points.map((point) => (
                                    <li key={point} className="flex items-start gap-3">
                                        <span className="w-2 h-2 bg-secondary rounded-full mt-2"></span>
                                        {point}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="h-full rounded-2xl bg-gradient-to-br from-bgMuted to-bgLight border border-secondary/30 flex-col mb-8 min-h-[600px] sm:w-[500px] md:ml-16 ml-0 shadow-lg overflow-hidden">
                        <div className="text-left">
                            <h2 className="mt-0 text-2xl font-serif font-bold mb-4 lg:pl-10 sm:pl-4 pr-24 py-4 bg-primary text-white">{home.platformHeading}</h2>
                        </div>
                        <div className="px-8 py-4">
                            <ul className="text-lg text-left font-medium text-textDark space-y-4">
                                {platform.offerings.map((item) => item.free ? (
                                    <li key={item.name} className="flex items-center gap-3 text-accent">
                                        <span className="w-3 h-3 bg-accent/50 rounded-full"></span>
                                        <span className="text-sm">{item.name}</span>
                                    </li>
                                ) : (
                                    <li key={item.name} className="flex items-center gap-3 hover:text-primary transition-colors">
                                        <span className="w-3 h-3 bg-secondary rounded-full"></span>
                                        {item.name}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Review Cards Section */}
                <div className="my-16 md:px-16 flex flex-col" id="reviews">
                    <h2 className="text-3xl font-serif font-bold text-center text-primary mb-8 p-4 w-fit flex self-center">{home.reviewsHeading}</h2>
                    <Slider {...settings}>
                        {reviews.map((r, i) => (
                            <ReviewCard key={i} name={r.name} review={r.review} rating={r.rating} />
                        ))}
                    </Slider>
                </div>
            </div>
            <Footer/>
        </div>
  )
}
